import { Helmet } from "react-helmet-async"
import { HotelPolicies, IHotel } from "../../../../Hotels"
import { useOutletContext } from "../../../../router-utils"

export default function HotelPoliciesPage() {
	const { hotel, revalidate } = useOutletContext<{
		hotel: IHotel
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Policies | Hotel</title>
			</Helmet>
			<HotelPolicies hotel={hotel} onChange={revalidate} />
		</>
	)
}
